'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionCustom = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _OptionCustomStyled = require('./styles/OptionCustomStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  fullWidth: _propTypes2.default.bool,
  dense: _propTypes2.default.bool,
  selected: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  text: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  index: _propTypes2.default.number
};
var defaultProps = {
  fullWidth: false,
  dense: false,
  selected: false,
  disabled: false,
  text: '',
  onClick: _reactackleCore.noop,
  onKeyDown: _reactackleCore.noop,
  index: 0
};

var OptionCustom = exports.OptionCustom = function (_Component) {
  _inherits(OptionCustom, _Component);

  function OptionCustom(props) {
    _classCallCheck(this, OptionCustom);

    var _this = _possibleConstructorReturn(this, (OptionCustom.__proto__ || Object.getPrototypeOf(OptionCustom)).call(this, props));

    _this.state = {};
    _this._handleKeyDown = _this._handleKeyDown.bind(_this);
    _this._handleClick = _this._handleClick.bind(_this);
    return _this;
  }

  _createClass(OptionCustom, [{
    key: '_handleKeyDown',
    value: function _handleKeyDown(event) {
      if (event.keyCode === 32) {
        event.preventDefault();
        this.props.onClick(this.props.index);
      }

      this.props.onKeyDown(this.props.index, event);
    }
  }, {
    key: '_handleClick',
    value: function _handleClick() {
      this.props.onClick(this.props.index);
    }
  }, {
    key: 'render',
    value: function render() {
      var itemProps = !this.props.disabled ? {
        onClick: this._handleClick,
        onKeyDown: this._handleKeyDown,
        tabIndex: 0
      } : {};
      return _react2.default.createElement(_OptionCustomStyled.OptionCustomStyled, _extends({}, itemProps, {
        disabled: this.props.disabled,
        selected: this.props.selected,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth
      }), this.props.text);
    }
  }]);

  return OptionCustom;
}(_react.Component);

OptionCustom.propTypes = propTypes;
OptionCustom.defaultProps = defaultProps;
OptionCustom.displayName = 'OptionCustom';